// Desfecho de um Lead (em aberto, ganho ou perdido) — ver GLOSSARY.md.
// Única regra do sistema: a Etapa diz explicitamente se é de ganho ou de perda
// (funnel_stages.outcome). O nome da Etapa nunca é usado.

export type DesfechoEtapa = 'won' | 'lost';

export interface EtapaComDesfecho {
  id: number;
  name: string;
  original_id?: string | null;
  outcome?: DesfechoEtapa | null;
}

export function desfechoDaEtapa(etapa: EtapaComDesfecho): DesfechoEtapa | null {
  if (etapa.outcome) return etapa.outcome;
  // Compatibilidade: etapas antigas e as sintéticas "Ganho"/"Perdido" do Kanban.
  if (etapa.original_id === 'won' || etapa.original_id === 'lost') return etapa.original_id;
  return null;
}

export type DesfechoLead = DesfechoEtapa | 'open';

// `leads.status` guarda a etapa como original_id (quando existe) ou o id numérico
// em texto; aceita os dois para não depender de qual formato o lead tem.
function etapaDoStatus(status: string, etapas: EtapaComDesfecho[]): EtapaComDesfecho | undefined {
  return etapas.find(e => (e.original_id && e.original_id === status) || String(e.id) === status);
}

export function desfechoDoLead(status: string | null | undefined, etapas: EtapaComDesfecho[]): DesfechoLead {
  if (!status) return 'open';
  if (status === 'won' || status === 'lost') return status;
  const etapa = etapaDoStatus(status, etapas);
  return (etapa && desfechoDaEtapa(etapa)) || 'open';
}

// Valores de `leads.status` que correspondem a um Desfecho — para filtrar no servidor.
export function statusesDoDesfecho(etapas: EtapaComDesfecho[], desfecho: DesfechoEtapa): string[] {
  const valores = new Set<string>([desfecho]);
  etapas.filter(e => desfechoDaEtapa(e) === desfecho).forEach(e => {
    valores.add(String(e.id));
    if (e.original_id) valores.add(e.original_id);
  });
  return [...valores];
}

// A Etapa de ganho (ou de perda) do funil, se houver.
export function etapaDoDesfecho<T extends EtapaComDesfecho>(etapas: T[], desfecho: DesfechoEtapa): T | undefined {
  return etapas.find(e => desfechoDaEtapa(e) === desfecho);
}
